import { render, staticRenderFns } from "./Artboard16.vue?vue&type=template&id=1d192cf2&"
import script from "./Artboard16.vue?vue&type=script&lang=js&"
export * from "./Artboard16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports